import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Activity from './Activity';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: { marginLeft: theme.spacing(1) },
  contentWrapper: {
    height: 'calc(100vh - 240px)',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: 10
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 10
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#757575',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#808080',
      width: 15
    }
  },
  content: {
    width: '100%',
    paddingBottom: theme.spacing(4)
  },
  title: {
    marginBottom: theme.spacing(3)
  },
  group: {
    '& + &': {
      marginTop: theme.spacing(4)
    }
  },
  activity: {
    position: 'relative',
    '& + &': {
      marginTop: theme.spacing(3),
      '&:before': {
        position: 'absolute',
        content: '" "',
        height: 20,
        width: 1,
        top: -20,
        left: 20,
        backgroundColor: theme.palette.divider
      }
    }
  }
}));

function Activities({ activities, className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.root} >
      <Box className={classes.contentWrapper}>
        <Grid className={classes.content} container  >
          <Grid item xs={12} className={clsx(classes.root, className)} {...rest}>
            <Typography className={classes.title} variant="h3" color="textPrimary">
              {t('glassClaimTabs.activities')}
            </Typography>
            {activities.map(activity => (
              <Activity
                activity={activity}
                className={classes.activity}
                key={activity.id}
              />
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

Activities.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })).isRequired,
  className: PropTypes.string,
};

export default Activities;
